const root = "Course";
export const SET = `${root}/set`;
export const SETSTATE = `${root}/set`;
export const REMOVE = `${root}/remove`;
export const UPDATE = `${root}/update`;
export const LOADER = `${root}/loader`;
